import * as echarts from 'echarts';

// Utility function to create X-axis configuration
export const createXAxisConfig = (
  isDark: boolean,
  axisColor: string,
  timezone?: string,
  formatInUserTimezone?: (timestamp: string, format: string) => string,
): echarts.XAXisComponentOption => {
  return {
    type: 'time',
    axisLabel: {
      color: axisColor,
      fontSize: 10,
      rotate: 30,
      margin: 20,
      hideOverlap: true,
      align: 'center',
      formatter: (value: number) => {
        // Format following forecast page pattern
        if (timezone === 'UTC') {
          return new Date(value).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'UTC',
          });
        } else if (formatInUserTimezone) {
          return formatInUserTimezone(new Date(value).toISOString(), 'MMM d, HH:mm');
        } else {
          return new Date(value).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          });
        }
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: isDark ? '#374151' : '#E5E7EB',
        type: 'dashed',
      },
    },
    axisLine: {
      lineStyle: {
        color: axisColor,
      },
    },
  };
};
